<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in"></notifications>
    <router-view name="header"></router-view>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-notifyjs/themes/default.css'
  import Vue from 'vue'
  import Toasted from 'vue-toasted'
  Vue.use(Toasted, {
    iconPack : 'material' // set your iconPack, defaults to material. material|fontawesome|custom-class
});
  export default {
        data() {
            return {
                showMessage: true,
                // refresh variables
                refreshing: false,
                registration: null,
                updateExists: false,
            };
        },
        methods: {
            hideMessage() {
                this.showMessage = false
            },
            showRefreshUI(e) {
                this.$store.commit('reloadPage',true);
                this.registration = e.detail
                this.updateExists = true
                Vue.toasted.show(
                    'EMI tiene una nueva versión', {
                        position: 'bottom-center',
                        fullWidth: true,
                        // fitToScreen: true,
                        icon : {
                            name : 'cached',
                            after : false
                        },
                        action : [
                            {
                                text : 'Refrescar',
                                onClick : (e, toastObject) => {
                                    this.refreshApp();
                                }
                            },
                        ]
                });
            },
            refreshApp() {
                this.$store.commit('reloadPage',false);
                this.updateExists = false
                if (!this.registration || !this.registration.waiting) return
                // send message to SW to skip the waiting and activate the new SW
                this.registration.waiting.postMessage('skipWaiting')
            },
        },
        created() {
            // --- 
            // Custom code to let user update the app
            // when a new service worker is available
            // --- 
            document.addEventListener('swUpdated', this.showRefreshUI, {once: true})                        
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (this.refreshing) return
                this.refreshing = true
                // Here the actual reload of the page occurs
                window.location.reload()
            })
        },
        mounted () {
            
        }
    };
</script>
<style lang="sass">

</style>
